module.exports = __webpack_public_path__ + "img/balken.ff4ed4b3.jpg";